import SectionHeading from '@/components/base/SectionHeading';
import CultureCard from '@/components/feature/CultureCard';
import { cultureItems } from '@/mocks/culture';

export default function HomeCulture() {
  const featured = cultureItems.slice(0, 3);

  return (
    <section className="shell py-12 md:py-16">
      <SectionHeading
        eyebrow="Culture & Essays"
        title="文化专题精选"
        description="动漫不只是娱乐。我们尝试把作品放回它的文化语境里，慢慢读，慢慢聊。"
        actionLabel="全部文化专题"
        actionTo="/category/culture"
      />

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {featured.map((item) => (
          <CultureCard key={item.id} item={item} />
        ))}
      </div>
    </section>
  );
}